import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {AppState} from 'store/types';
import {TeaserWpArticle} from 'utils/types';
import getTeaserWpArticlesThunk from 'store/teaserWpArticles/actions/getWpTeaserArticles';

/**
 * Return type of the useTeaserArticles hook
 */
type UseTeaserArticlesResult = [
  {loading: boolean; data?: TeaserWpArticle[]; error?: string | boolean},
  {getTeaserArticles: typeof getTeaserWpArticlesThunk}
];

/**
 * Selects the 'teaserArticles' state and sum it up into a referring object
 */
const teaserArticlesSelector = (state: AppState) => ({
  loading: state.teaserWpArticles.isFetching,
  data: state.teaserWpArticles.data,
  error: state.teaserWpArticles.didInvalidate ? state.teaserWpArticles.error : false,
});

/**
 * Wraps up the business logic of selecting the 'teaserArticles' state.
 */

const useTeaserArticles = (): UseTeaserArticlesResult => {
  const dispatch = useDispatch();
  const state = useSelector(teaserArticlesSelector);

  const getTeaserArticles = useCallback(() => dispatch(getTeaserWpArticlesThunk()), [dispatch]);

  return [state, {getTeaserArticles}];
};

export default useTeaserArticles;
